/**
 * JavascriptLoader.
 */
export default class JavascriptLoader {
	private element = document.createElement('script');

	/**
	 *
	 * @param url Url to script file.
	 */
	constructor(url) {
		this.element.src = url;
	}
	/**
	 * Load a script by adding a script tag.
	 *
	 * @returns Promise event.
	 */
	public load(): Promise<Event> {
		return new Promise((resolve, reject) => {
			this.element.addEventListener('load', resolve);
			this.element.addEventListener('error', reject);
			this.element.async = true;
			document.head.appendChild(this.element);
		});
	}
}
